"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var RetryPolicy = /** @class */ (function () {
    function RetryPolicy() {
    }
    RetryPolicy.waitAndRetry = function (_a) {
        var retryCount = _a.retryCount, sleepDurationProvider = _a.sleepDurationProvider;
        validateRetryCount(retryCount);
        validateSleepDurationProvider(sleepDurationProvider);
        var policy = new RetryPolicy();
        policy._retryCount = retryCount;
        policy._sleepDurationProvider = sleepDurationProvider;
        return policy;
    };
    RetryPolicy.waitAndRetryForever = function (_a) {
        var sleepDurationProvider = _a.sleepDurationProvider;
        validateSleepDurationProvider(sleepDurationProvider);
        var policy = new RetryPolicy();
        policy._retryCount = Number.MAX_VALUE;
        policy._sleepDurationProvider = sleepDurationProvider;
        return policy;
    };
    RetryPolicy.prototype.untilValidResult = function (resultValidator) {
        if (typeof resultValidator !== 'function') {
            throw new Error('If provided, the result validator must be a function.');
        }
        this._isValidResult = resultValidator;
        return this;
    };
    RetryPolicy.prototype.executeAsync = function (asyncFunc, cancellationToken) {
        return __awaiter(this, void 0, void 0, function () {
            var i, result, e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!asyncFunc || typeof asyncFunc !== 'function') {
                            throw new Error('asyncFunction must be provided.');
                        }
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i < this._retryCount - 1)) return [3 /*break*/, 8];
                        if (isTokenCanceled(cancellationToken)) {
                            return [2 /*return*/];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, asyncFunc(cancellationToken)];
                    case 3:
                        result = _b.sent();
                        if (!this._isValidResult || this._isValidResult(result)) {
                            return [2 /*return*/, result];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, utils_1.sleepAsync(this.getSleepDuration(i + 1), cancellationToken)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        i++;
                        return [3 /*break*/, 1];
                    case 8:
                        if (!!isTokenCanceled(cancellationToken)) return [3 /*break*/, 10];
                        return [4 /*yield*/, asyncFunc(cancellationToken)];
                    case 9:
                        _a = _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _a = undefined;
                        _b.label = 11;
                    case 11: return [2 /*return*/, _a];
                }
            });
        });
    };
    RetryPolicy.prototype.getSleepDuration = function (retryAttempt) {
        if (!this._sleepDurationProvider) {
            return 0;
        }
        return typeof this._sleepDurationProvider === 'function'
            ? this._sleepDurationProvider({ retryAttempt: retryAttempt })
            : this._sleepDurationProvider;
    };
    return RetryPolicy;
}());
exports.RetryPolicy = RetryPolicy;
function isTokenCanceled(cancellationToken) {
    return cancellationToken && cancellationToken.isCancellationRequested;
}
function validateRetryCount(retryCount) {
    if (typeof retryCount !== 'number' || retryCount <= 0) {
        throw new Error('Retry count must be set and greater than 0.');
    }
}
function validateSleepDurationProvider(sleepDurationProvider) {
    if (sleepDurationProvider != null &&
        typeof sleepDurationProvider !== 'function' &&
        typeof sleepDurationProvider !== 'number') {
        throw new Error('If provided, the sleep duration provider must be a function or number.');
    }
}
